/**
 * Fund Detail Page Route
 *
 * Displays detailed information about a specific mutual fund
 * using the FundDetailScreen component.
 *
 * Route: /funds/:fundId
 */

import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { FundDetailScreen } from "@/components/fund-detail";
import { GlobalErrorFallback } from "@/components/error";

export const Route = createFileRoute("/funds/$fundId")({
  component: FundDetailPage,
  errorComponent: GlobalErrorFallback,
});

function FundDetailPage() {
  const { fundId } = Route.useParams();
  const navigate = useNavigate();

  const handleBack = () => {
    // Navigate back to explore page or previous page
    navigate({ to: "/explore" });
  };

  return <FundDetailScreen fundId={fundId} onBack={handleBack} />;
}
